import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Intro from '@/components/Intro'
import Articles from '@/components/Articles'
import PjHonor from '@/components/PjHonor'
import ShenZhen from '@/components/ShenZhen'
import ShenShan from '@/components/ShenShan'
import Detail from '@/components/Detail'
import Talent from '@/components/Talent'
import CoVideos from '@/components/CoVideos'
import PjVideos from '@/components/PjVideos'
import AcVideos from '@/components/AcVideos'
import Architecture from '@/components/Architecture'
import DevelopmentCourse from '@/components/DevelopmentCourse'
import Responsibility from '@/components/Responsibility'
import ShowGrades from '@/components/ShowGrades'
import Culture from '@/components/Culture'
import IndustrialPark from '@/components/IndustrialPark'
import HonorMention from '@/components/HonorMention'
import '@/common/css/style.css'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/articles',
      name: 'Articles',
      component: Articles
    },
    {
      path: '/pjHonor',
      name: 'PjHonor',
      component: PjHonor
    },
    {
      path: '/shenZhen',
      name: 'ShenZhen',
      component: ShenZhen
    },
    {
      path: '/shenShan',
      name: 'ShenShan',
      component: ShenShan
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/talent',
      name: 'Talent',
      component: Talent
    },
    {
      path: '/coVideos',
      name: 'CoVideos',
      component: CoVideos
    },
    {
      path: '/pjVideos',
      name: 'PjVideos',
      component: PjVideos
    },
    {
      path: '/acVideos',
      name: 'AcVideos',
      component: AcVideos
    },
    {
      path: '/architecture',
      name: 'Architecture',
      component: Architecture
    },
    {
      path: '/developmentCourse',
      name: 'DevelopmentCourse',
      component: DevelopmentCourse
    },
    {
      path: '/responsibility',
      name: 'Responsibility',
      component: Responsibility
    },
    {
      path: '/showGrades',
      name: 'ShowGrades',
      component: ShowGrades
    },
    {
      path: '/culture',
      name: 'Culture',
      component: Culture
    },
    {
      path: '/industrialPark',
      name: 'IndustrialPark',
      component: IndustrialPark
    },
    {
      path: '/honorMention',
      name: 'HonorMention',
      component: HonorMention
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js